import * as React from "react";
import { Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LetsSizzle() {
  return <section data-section-id="223905" id="fair-economics-for-startups" className="relative w-full min-h-[70vh] flex items-center justify-center bg-background text-foreground overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 opacity-20 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/dark_slate_grit_texture.png)] bg-cover bg-center mix-blend-overlay pointer-events-none" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/40 to-background pointer-events-none" />

      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center gap-8">
        <div className="flex flex-col items-center justify-center w-full">
          <h1 className="font-default text-[18vw] sm:text-[15vw] md:text-[12vw] lg:text-[160px] xl:text-[200px] leading-[0.8] tracking-tighter uppercase flex flex-col items-center justify-center w-full">
            <span className="block w-full text-center" style={{
            WebkitTextStroke: "min(3px, 0.5vw) currentColor",
            color: "transparent"
          }}>
              PRICING
            </span>
            <span className="flex items-end justify-center w-full mt-2 md:mt-0">
              <span className="block" style={{
              WebkitTextStroke: "min(3px, 0.5vw) currentColor",
              color: "transparent"
            }}>
                SCALES
              </span>
              <span className="text-primary ml-2 md:ml-4 leading-[0.8] inline-block transform -rotate-12 drop-shadow-[0_0_20px_rgba(0,255,255,0.6)]">
                !
              </span>
            </span>
          </h1>
        </div>

        <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-2xl font-default mt-6 md:mt-12 px-4">
          Predictable IT support for growing teams at $110 per device. No hidden markups, no surprises—just the partnership your startup needs.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mt-8 w-full sm:w-auto px-4">
          <Button size="lg" className="h-16 px-10 text-lg font-default uppercase tracking-wider w-full sm:w-auto group shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all duration-300 bg-primary text-primary-foreground" asChild>
            <Link to="#">
              See Transparency
              <Flame className="ml-2 size-6 group-hover:text-cyan-300 transition-colors group-hover:scale-110 duration-300" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}